import * as React from 'react';
import { Datagrid, List, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';
import { ListActions } from '../../components/ListAction';
import { ListIsEmptyPage } from '../../components/ListIsEmptyPage';

export const PathsList = (props: unknown) => (
  <List sort={{ field: 'title', order: 'ASC' }} empty={<ListIsEmptyPage />} actions={<ListActions />} title={<CustomTitle />} {...props}>
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <TextField source="title" />
      <TextField source="id" />
    </Datagrid>
  </List>
);
